import React from 'react';
import { Loader2 } from 'lucide-react';
import { FeedHeader } from '@/components/FeedHeader';
import { FeedEntry } from '@/components/FeedEntry';
import { EmptyFeed } from '@/components/EmptyFeed';

export default function FeedList({ entries, loading, refreshing, onRefresh, filterType, onFilterChange, userName }) {
  return (
    <div className="max-w-3xl mx-auto">
      <FeedHeader
        filterType={filterType}
        onFilterChange={onFilterChange}
        refreshing={refreshing}
        onRefresh={onRefresh}
        userName={userName}
      />

      {loading ? (
        <div className="flex flex-col items-center justify-center py-20">
          <Loader2 strokeWidth={2.5} size={32} className="animate-spin text-pink-500 mb-4" />
          <p className="text-sm font-medium text-zinc-500">Loading your feed...</p>
        </div>
      ) : entries.length === 0 ? (
        <EmptyFeed />
      ) : (
        <div className="space-y-4">
          {entries.map((entry, i) => (
            <FeedEntry key={`${entry.link}-${i}`} entry={entry} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
